import React, { Component } from 'react';
import './FunctionPage.css';
import app_store from '../assets/images/ico_appstore.png';
import aos_store from '../assets/images/ico_playstore.png';
import FunctionCell from "./FunctionCell"

class FunctionPage extends Component {
  constructor(props) {
    super(props);

    this.pageData = [
      {
        url:"..",
        icon:require('../assets/images/screenshots/ico_001.png'),
        bg:require('../assets/images/screenshots/store01-1.png'),
        title:"감성과 공감",
        description:"책으로 시작되는 감성과 공감.\n읽은 책에 대한 생각을 나누고, 취향이 닮은 독서 친구를 만나보세요.\n추천과 리뷰, 독서 모임, 퀴즈와 출석까지\n책의 마지막 장을 덮은 뒤에도 이야기는 계속됩니다.",
      },
      {
        url:"..",
        icon:require('../assets/images/screenshots/ico_002.png'),
        bg:require('../assets/images/screenshots/store01-2.png'),
        title:"도서 리뷰",
        description:"읽은 책에 대한 생각을 기록하고\n다른 독자들의 감상과 공감을 나눠보세요.\n한 권의 책이 새로운 대화가 됩니다.",
      },
      {
        url:"..",
        icon:require('../assets/images/screenshots/ico_005.png'),
        bg:require('../assets/images/screenshots/store02-1.png'),
        title:"짝궁",
        description:"취향이 닮은 독서 친구, 짝궁을 만나보세요.\n서로의 감상평을 나누며\n자연스럽게 이어지는 인연을 발견할 수 있어요.",
      },
      {
        url:"..",
        icon:require('../assets/images/screenshots/ico_006.png'),
        bg:require('../assets/images/screenshots/store03-1.png'),
        title:"추천·비추천",
        description:"이 책, 어떻게 읽으셨나요?\n추천과 비추천으로 마음을 표현하고\n다른 독자들의 선택도 함께 확인해보세요.",
      },
      {
        url:"..",
        icon:require('../assets/images/screenshots/ico_003.png'),
        bg:require('../assets/images/screenshots/store03-2.png'),
        title:"독서 모임",
        description:"책을 좋아하는 사람들과 함께 읽고 이야기하세요.\n가까운 독서 모임을 찾고,\n우리 모임의 순간과 후기도 나눌 수 있어요.",
      },
      {
        url:"..",
        icon:require('../assets/images/screenshots/ico_quiz_book.png'),
        bg:require('../assets/images/screenshots/store04-1.png'),
        title:"퀴즈북",
        description:"읽은 책을 퀴즈로 다시 만나보세요.\n재미있게 참여하고 순위에 도전하며\n책 선물의 행운도 잡아보세요.",
      },
      {
        url:"..",
        icon:require('../assets/images/screenshots/ico_007.png'),
        bg:require('../assets/images/screenshots/store04-2.png'),
        title:"출석부",
        description:"매일 출석하고 작은 행운을 열어보세요.\n출석 횟수와 포인트를 쌓으며\n꾸준한 독서 습관을 이어갈 수 있어요.",
      },
    ];

    this.state = {
      scroll : 0,
      scrollOffset : 0,
      anim : true,
      scrolling : false,
      selectedPage : 0,
    }
    
    this.selectPage   = this.selectPage.bind(this);
    this.pageLeft     = this.pageLeft.bind(this);
    this.pageRight    = this.pageRight.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    
    this.startX = 0;
    this.startY = 0;

    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
  }

  render() {
    this.pageWidth    = window.innerWidth * 0.18;
    this.pageWidth    = Math.min(140, this.pageWidth);

    var transition = "none";
    if (this.state.anim) 
      transition = "all 0.2s ease 0s";

    var startOffset = Math.round(this.state.scroll / this.pageWidth - 5) % this.pageData.length;
    if (startOffset < 0)
      startOffset = this.pageData.length + (startOffset % this.pageData.length);  

    const selectedPage = this.pageData[this.state.selectedPage];

    return (
      <div className="FunctionPage">
        <div className="container" style={{marginBottom:"5vmin"}}>
          <div >
            <img id="bg" className="sshot" src={selectedPage.bg} alt={selectedPage.title} />
          </div>
          <div style={{margin:"3vw"}}/>
          <div className="info">
            <div className="title">{selectedPage.title}</div>
            <hr className='light' style={{marginTop:"5px", marginBottom:"15px"}}/>
            <pre className="description">{selectedPage.description}</pre>
            <div style={{margin:"5vh"}}/>
            <div className="store">
              <div>
                <img
                  className="img"
                  src={app_store}
                  alt="APPSTORE"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(
                      'itms-apps://itunes.apple.com/app/id6745247420',
                      '_blank'
                    );
                  }}
                />
              </div>

              <div>
                <img
                  className="img"
                  src={aos_store}
                  alt="GOOGLE PLAYSTORE"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(
                      'https://play.google.com/store/apps/details?id=com.lemoncake.mlibrary',
                      '_blank'
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="scroll_panel">
          <button style={{cursor:"pointer", backgroundColor:"transparent", border: "none", position:'relative', marginRight:"10px"}} onClick={this.pageLeft}>
              <img src={require('../assets/images/btn_move_left.png')}/>
          </button>
          <hr style={{border: "solid double 1px gray", height:"10vmin"}}/>
          <div className="clipping_panel">
            <div id="panel" onTouchStart={this.onTouchStart}
            onTouchMove={this.onTouchMove}
            onTouchEnd={this.onTouchEnd}
            className="scroll_view" style={{left: this.state.scrollOffset - this.pageWidth * 5, WebkitTransition:transition}}> 
              <FunctionCell data={this.pageData[startOffset]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 1) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 2) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 3) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 4) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 5) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 6) % this.pageData.length]} onSelect={this.selectPage}/>              
              <FunctionCell data={this.pageData[(startOffset + 7) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 8) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 9) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 10) % this.pageData.length]} onSelect={this.selectPage}/>
              <FunctionCell data={this.pageData[(startOffset + 11) % this.pageData.length]} onSelect={this.selectPage}/>              
              <FunctionCell data={this.pageData[(startOffset + 12) % this.pageData.length]} onSelect={this.selectPage}/>              
            </div>
          </div>
          <hr style={{border: "solid double 1px gray", height:"10vmin"}}/>
          <button style={{cursor:"pointer", backgroundColor:"transparent", border: "none", position:'relative', marginLeft:"10px"}} onClick={this.pageRight}>
              <img src={require('../assets/images/btn_move_right.png')}/>
          </button>
        </div>
      </div>
    );
  }

  async pageRight() {
    if (this.state.scrolling)
      return;
      
    const current = this.state.scroll + this.pageWidth
    this.setState({scrollOffset: -this.pageWidth, anim: true, scrolling: true});

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    await sleep(1);

    this.setState({scroll: current, scrollOffset: 0, anim: false, scrolling: false})
  }

  async pageLeft() {
    if (this.state.scrolling)
      return;

    const current = this.state.scroll - this.pageWidth
    this.setState({scrollOffset: this.pageWidth, anim: true, scrolling: true});

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    await sleep(1);

    this.setState({scroll: current, scrollOffset: 0, anim: false, scrolling: false})
  }

  selectPage(page) {
    this.setState({selectedPage: this.pageData.indexOf(page)});
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowDimensions);
    //document.addEventListener("touchstart", this.setEventTouch);
    //document.addEventListener("touchmove", this.setEventTouch);
    //document.addEventListener("touchend", this.setEventTouch);
    //document.addEventListener("touchcancel", this.setEventTouch);
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    //document.removeEventListener("touchstart", this.setEventTouch);
    //document.removeEventListener("touchmove", this.setEventTouch);
    //document.removeEventListener("touchend", this.setEventTouch);
    //document.removeEventListener("touchcancel", this.setEventTouch);
  }

  updateWindowDimensions() {
    this.setState({ scroll: 0, scrollOffset: 0 });
  }

  onTouchStart(e) {
    this.startX = e.changedTouches[0].pageX;
    this.startY = e.changedTouches[0].pageY;
  }

  onTouchMove(e) {
    const divOverlay = document.getElementById("panel");

    var deltaX = e.changedTouches[0].pageX - this.startX;
    var deltaY = e.changedTouches[0].pageY - this.startY;

    this.setState({scrollOffset:this.state.scrollOffset + deltaX});

    this.startX = e.changedTouches[0].pageX;
    this.startY = e.changedTouches[0].pageY;
  }

  async onTouchEnd(e) {
    const current = Math.round(this.state.scrollOffset / this.pageWidth) * this.pageWidth;
    this.setState({scrollOffset: current, anim: true, scrolling: true});

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    await sleep(300);

    console.log(current);
    this.setState({scroll: this.state.scroll - current, scrollOffset: 0, anim: false, scrolling: false})
  }
}

export default FunctionPage;
